/* eslint-disable @typescript-eslint/dot-notation */
/**
 * When we think of a particular color name, we mean this hex code.
 * These keys can be used to describe color themes.
 */
export const COLOR_VALUES = {
  white: '#ffffff',
  black: '#000000',
  solitude: '#f7f9fa',
  'dark-solitude': '#eaedf1',
  silver: '#bac1c8',
  'silver-chalice': '#9ba3ad',
  'gun-powder': '#4c545d',
  'mine-shaft': '#272b2f',
  'light-steel-blue': '#e2ebf5',
  nepal: '#accdf2',
  'steel-blue': '#6babf3',
  attribluetion: '#126cd3',
  'smugglers-cove': '#1755a0',
  'gray-500': '#6E7787',
  'gray-600': '#566171',
  'green-500': '#13a45e',
  'blue-300': '#93c5fd',
  'blue-600': '#2563eb',
  'blue-800': '#0951A5',
};

/**
 * This is a generic, non-branded theme.
 * This theme should be always be applied to the page.
 */
export const THEME_BASE = {
  '--color-white': COLOR_VALUES['white'],
  '--color-black': COLOR_VALUES['black'],
  '--color-dark-solitude': COLOR_VALUES['dark-solitude'],
  '--color-silver': COLOR_VALUES['silver'],
  '--color-silver-chalice': COLOR_VALUES['silver-chalice'],
  '--color-gun-powder': COLOR_VALUES['gun-powder'],
  '--color-mine-shaft': COLOR_VALUES['mine-shaft'],
  '--color-solitude': COLOR_VALUES['solitude'],
  '--color-light-steel-blue': COLOR_VALUES['light-steel-blue'],
  '--color-nepal': COLOR_VALUES['nepal'],
  '--color-steel-blue': COLOR_VALUES['steel-blue'],
  '--color-gray-500': COLOR_VALUES['gray-500'],
  '--color-gray-600': COLOR_VALUES['gray-600'],
  '--color-green-500': COLOR_VALUES['green-500'],
  '--color-blue-300': COLOR_VALUES['blue-300'],
  '--color-blue-600': COLOR_VALUES['blue-600'],
  '--color-blue-800': COLOR_VALUES['blue-800'],

  /**
   * The following colors do not match their names. This is to provide a generic palette that is not
   * aware of the CallRail brand.
   * */
  '--color-attribluetion': COLOR_VALUES['mine-shaft'],
  '--color-smugglers-cove': COLOR_VALUES['mine-shaft'],
};

/**
 * This is a generic, non-branded theme.
 * This theme is applied on top of the generic theme, so it only needs to describe the
 * colors that are different than the defaults described above.
 */
export const THEME_CALLRAIL = {
  '--color-attribluetion': COLOR_VALUES['attribluetion'],
  '--color-smugglers-cove': COLOR_VALUES['smugglers-cove'],
};
